import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table, Input,
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { FileInput, Preview } from '../../../../helpers/ui/FileInput'

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import Shimmer from "react-shimmer-effect"
import moment from 'moment'

class DetailView extends Component {
    
    indexBloc = new IndexBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            type: null,
            isDraft: 0,
            detail: null,
            inactiveUuid: null,
            tableData: [],
            employeeOption: [],
            positionOption: [],
            workUnitOption: [],
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            },
            positionFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'position_id',
                    order: 'asc' 
                }
            },
            workUnitFilter: {
                filter_value: "",
                page_number: 1,
                page_size: this.defaultSize,
                sort_order: {
                    column: 'work_unit_id',
                    order: 'asc' 
                }
            },
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    addTableData = () => {
        const { tableData } = this.state
        let data = {
            id: this.makeid(6),
            additional_task_detail_uuid: null,
            additional_task_detail_employee_uuid: null,
            additional_task_detail_position_uuid: null,
            additional_task_detail_work_unit_uuid: null,
            additional_task_detail_workgroup: null 
        }

        this.setState({ tableData: [ ...tableData, data ] })
    }

    removeTableData = (id) => {
        const { tableData } = this.state
        let newArr = tableData.filter(val => val.id != id)

        this.setState({ tableData: newArr })
    }


    loadEmployee = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        this.setState({ loadingEmployee: true })
        await this.indexBloc.fetchListPegawai(query)
    }

    loadPosition = async (type) => {
        let offset = (this.state.positionFilter.page_number-1)*this.state.positionFilter.page_size
        const query = {
            search: this.state.positionFilter.filter_value,
            limit: this.state.positionFilter.page_size,
            offset: offset,
            order: this.state.positionFilter.sort_order.column,
            sort: this.state.positionFilter.sort_order.order,
            status: 1,
            type: type + 2
        }
        this.setState({ loadingPosition: true })
        await this.indexBloc.fetchListJabatan(query)
    }

    loadWorkUnit = async () => {
        let offset = (this.state.workUnitFilter.page_number-1)*this.state.workUnitFilter.page_size
        const query = {
            search: this.state.workUnitFilter.filter_value,
            limit: this.state.workUnitFilter.page_size,
            offset: offset,
            order: this.state.workUnitFilter.sort_order.column,
            sort: this.state.workUnitFilter.sort_order.order,
            status: 1,
        }
        this.setState({ loadingWorkUnit: true })
        await this.indexBloc.fetchListUnitKerja(query)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadEmployee()
        this.loadWorkUnit()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            const { tableData } = this.state
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.loadPosition(result.data.response.additional_task_type)
                    const detail = result.data.response.detail
                    if (detail.length > 0) {
                        let array = []
                        detail.forEach((val, i) => {
                            let data = {
                                id: this.makeid(6), 
                                ...val
                            } 
                            array.push(data)
                        });
                        this.setState({ tableData: array })
                    }
                    this.setState({ detail: result.data.response, type: result.data.response.additional_task_type })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.listPegawaiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response.result, loadingEmployee: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        });

        this.indexBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.listUnitKerjaChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ workUnitOption: result.data.response.result, loadingWorkUnit: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.listPegawaiChannel?.unsubscribe()
        this.indexBloc.listJabatanChannel?.unsubscribe()
        this.indexBloc.listUnitKerjaChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
    }


    render() {
        const { type, detail, tableData } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/petajabatan.html`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>        
                            <CardTitle>Form Jabatan Pengelola Anggaran</CardTitle>
                            <CardSubtitle className="mb-3" style={{ padding: 3 }}>
                            </CardSubtitle>
                            <hr/>

                            <Fragment>
                                <Row className="mb-3">
                                    <Label
                                        className="col-md-1 col-form-label"
                                    >
                                        Nomor SK <span className="text-danger">*</span>
                                    </Label>
                                    { detail ?
                                        <Col md="3">
                                            <Input
                                                name="additional_task_decree_number"
                                                placeholder="Nomor SK"
                                                errorMessage="Masukkan Nomor SK"
                                                type="text"
                                                className="form-control"
                                                value={detail?.additional_task_decree_number}
                                                validate={{ required: { value: true } }}
                                                readOnly={true}
                                            />
                                        </Col>
                                        :
                                        <Shimmer>
                                            <Label className="col-md-3 col-form-label"></Label>
                                        </Shimmer>
                                    }
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-1 col-form-label"
                                    >
                                        Tanggal SK <span className="text-danger">*</span>
                                    </Label>
                                    { detail ?
                                        <Col md="3">
                                            <Input
                                                name="additional_task_decree_date"
                                                placeholder="Tanggal SK"
                                                errorMessage="Masukkan Tanggal SK"
                                                type="date"
                                                className="form-control"
                                                value={detail?.additional_task_decree_date}
                                                validate={{ required: { value: true } }}
                                                readOnly={true}
                                            />
                                        </Col>
                                        :
                                        <Shimmer>
                                            <Label className="col-md-3 col-form-label"></Label>
                                        </Shimmer>
                                    }
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-1 col-form-label"
                                    >
                                        TMT SK <span className="text-danger">*</span>
                                    </Label>
                                    { detail ? 
                                        <Col md="3">
                                            <Input
                                                name="additional_task_tmt_date"
                                                placeholder="TMT SK"
                                                errorMessage="Masukkan TMT SK"
                                                type="date"
                                                className="form-control"
                                                value={detail?.additional_task_tmt_date}
                                                validate={{ required: { value: true } }}
                                                readOnly={true}
                                            />
                                        </Col>
                                        :
                                        <Shimmer>
                                            <Label className="col-md-3 col-form-label"></Label>
                                        </Shimmer>
                                    }
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-1 col-form-label"
                                    >
                                        Upload SK 
                                    </Label>
                                    <Col md="3">
                                        <Preview
                                            isAvForm={false}
                                            name="additional_task_document_uuid"
                                            placeholder="Upload SK"
                                            className="form-control"
                                            col="6"
                                            value={detail?.document}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label
                                        className="col-md-1 col-form-label"
                                    >
                                        Jenis Jabatan
                                    </Label>
                                    { detail ? 
                                        <Col md="3">
                                            <Select
                                                isAvForm={false}
                                                name="additional_task_type"
                                                placeholder="Jenis Jabatan"
                                                errorMessage="Pilih Jenis Jabatan"
                                                options={[
                                                    { value: 1, label: 'Pengelola Anggaran' },
                                                    { value: 2, label: 'Pembantu Pengelola Anggaran' },
                                                    { value: 3, label: 'POKJA' }, 
                                                    { value: 4, label: 'PLT' }, 
                                                    { value: 5, label: 'PLH' }
                                                ]}
                                                onChange={opt => this.setState({ type: opt.value })}
                                                defaultValue={type}
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                isDisabled={true}
                                            />
                                        </Col>
                                        :
                                        <Shimmer>
                                            <Label className="col-md-3 col-form-label"></Label>
                                        </Shimmer>
                                    }
                                </Row>

                                <hr/>
                                <Row>
                                    <Col md="12">
                                        <hr/>
                                        <Table>
                                            <thead>
                                                    <tr>
                                                        <th width="25px">No</th>
                                                        <th className="text-center">NIP - Nama<br />Jabatan</th>
                                                        {/* <th className="text-center"></th> */}
                                                        { (this.state.type == 1 || this.state.type == 2 || this.state.type == null) &&
                                                            <>
                                                                <th className="text-center" width="35%">Jabatan Pengelola Anggaran<br />Satuan Kerja/Unit</th>
                                                            </>
                                                        }
                                                        { this.state.type == 3 &&
                                                            <Fragment>
                                                                <th className="text-center" width="35%">Kelompok Kerja<br />Jabatan Kelompok Kerja</th>
                                                            </Fragment>
                                                        }
                                                        { (this.state.type == 4 || this.state.type == 5) &&
                                                            <Fragment>
                                                                <th className="text-center" width="35%">Jabatan {this.state.type == 4 ? 'PLT' : 'PLH'}<br />Satuan Kerja/Unit</th>
                                                            </Fragment>
                                                        }
                                                        <th width="15%" className="text-center">Tanggal Mulai<br />Tanggal Selesai</th>
                                                    </tr>
                                            </thead>
                                            <tbody>
                                                { tableData?.map((val, i) => {
                                                    return (
                                                        <tr key={val.id}>
                                                            <td>
                                                                {i + 1}
                                                            </td>
                                                            <td>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <Input 
                                                                            value={`${val.employee_nip} ${val.employee_full_name}`}
                                                                            readOnly={true}
                                                                        />
                                                                    </Col>
                                                                    <Col md={12} className="mt-2">
                                                                        <Input 
                                                                            value={val.employee_current_position_name}
                                                                            readOnly={true}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </td>
                                                                { (this.state.type == 1 || this.state.type == 2 || this.state.type == null) &&
                                                                <>
                                                                    <td>
                                                                        <Row>
                                                                            <Col md={12}>
                                                                                <Input 
                                                                                    value={`${val.additional_task_detail_position_name}`}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                            <Col md={12} className="mt-2">
                                                                                <Input 
                                                                                    value={val.additional_task_detail_work_unit_name}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </>
                                                                }
                                                                { this.state.type == 3 && 
                                                                <>
                                                                    <td>
                                                                        <Row>
                                                                            <Col md={12}>
                                                                                <Input 
                                                                                    value={`${val.additional_task_detail_workgroup}`}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                            <Col md={12} className="mt-2">
                                                                                <Input 
                                                                                    value={val.employee_current_position_name}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </>
                                                                }
                                                                { (this.state.type == 4 || this.state.type == 5) &&
                                                                <>
                                                                    <td>
                                                                        <Row>
                                                                            <Col md={12}>
                                                                                <Input 
                                                                                    value={`${val.additional_task_detail_position_name}`}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                            <Col md={12} className="mt-2">
                                                                                <Input 
                                                                                    value={val.additional_task_detail_work_unit_name}
                                                                                    readOnly={true}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </td>
                                                                </>
                                                                }
                                                            <td>
                                                                <Row>
                                                                    <Col md={12}>
                                                                        <Input 
                                                                            value={`${this.dateParse(val.additional_task_detail_start_date)}`}
                                                                            readOnly={true}
                                                                        />
                                                                    </Col>
                                                                    <Col md={12} className="mt-2">
                                                                        <Input 
                                                                            value={this.dateParse(val.additional_task_detail_end_date)}
                                                                            readOnly={true}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </td>
                                                        </tr>
                                                    )
                                                }) }
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>


                            </Fragment>

                        </CardBody>
                    </Card>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView;